// General
import React, { Component } from 'react';
import { connect } from 'react-redux';
// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import {
    Grid,
    Row,
    Col
} from 'react-bootstrap';
// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../locale/messages';
import getLocalizedContent from '../../core/helpers/getLocalizedContent';

import s from './BlogContent.css';

class BlogContent extends Component {
    render() {
        const { initialValues, locale } = this.props;
        let addClass = 'ql-editor frontend';

        // Get localized content
        const pageTitle = getLocalizedContent(initialValues, 'pageTitle', locale);
        const content = getLocalizedContent(initialValues, 'content', locale);

        return (
            <Grid fluid className={s.root}>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={cx(s.spaceTop3, s.space6)}>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <div>
                                {/* <h1 className={s.titleText}>{pageTitle}</h1> */}
                            </div>
                            <div className={s.subText}>
                                <div className={addClass} dangerouslySetInnerHTML={{ __html: content }} >
                                </div>
                            </div>
                        </Col>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

const mapState = (state) => ({
    locale: state.intl.locale
});

export default connect(mapState)(withStyles(s)(BlogContent));
